import MyBread from "../../components/Breadcrumbs";
import React, { useEffect, useState, Dispatch, SetStateAction } from "react";
import MaterialTable from "material-table";
import { ThemeProvider, createTheme } from "@mui/material";
import { useAuth } from "../../hooks/use-auth";
import axios from "axios";
import SubmitPerformances from "components/SubmitPerformances";
import AppearPerformances from "components/AppearPerformances";
import { Wrapper, PageTitle } from "styles/styles";

interface ParentProps {
  data: ParentDataProps[];
  selectedId: number;
  setSelectedId: Dispatch<SetStateAction<number>>;
  setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ParentDataProps {
  records_product_number_id: number;
  process_id: number;
  process_display_id: string;
  process_name: string;
  equipment_id: number;
  equipment_display_id: string;
  equipment_name: string;
  charged_user_id: number;
  charged_user_display_id: string;
  charged_user_name: string;
  volume: number;
  setup_time: string;
  tact_time: string;
  start_date: string;
  end_date: string;
  estimated_time: string;
  process_deadline: string;
  is_outsourcing: number;
  memo: string;
  [key: string]: string | number | Date;
}

const Parent = ({
  data,
  selectedId,
  setSelectedId,
  setIsParentDataInsert,
}: ParentProps) => {
  //arrayの生成

  const parentArray = [
    { title: "", field: "records_order_id" },
    { title: "受注管理No", field: "display_id" },
    { title: "", field: "records_product_number_id" },
    { title: "製番", field: "serial_number" },
    { title: "製番_枝番", field: "serial_number_branch" },
    { title: "", field: "records_process_id" },
    { title: "受注日", field: "order_date" },
    { title: "希望納期", field: "customer_deadline" },
    { title: "工程1", field: "records_process_id_1" },
    { title: "工程2", field: "records_process_id_2" },
    { title: "工程3", field: "records_process_id_3" },
    { title: "工程4", field: "records_process_id_4" },
    { title: "工程5", field: "records_process_id_5" },
    { title: "工程6", field: "records_process_id_6" },
    { title: "工程7", field: "records_process_id_7" },
    { title: "工程8", field: "records_process_id_8" },
    { title: "工程9", field: "records_process_id_9" },
    { title: "工程10", field: "records_process_id_10" },
    { title: "工程11", field: "records_process_id_11" },
    { title: "工程12", field: "records_process_id_12" },
    { title: "工程13", field: "records_process_id_13" },
    { title: "工程14", field: "records_process_id_14" },
    { title: "工程15", field: "records_process_id_15" },
    { title: "工程16", field: "records_process_id_16" },
    { title: "工程17", field: "records_process_id_17" },
    { title: "工程18", field: "records_process_id_18" },
    { title: "工程19", field: "records_process_id_19" },
    { title: "工程20", field: "records_process_id_20" },
  ];
  const PAGE_TITLE = "工程進捗状況一覧";
  const columnsArray: any = [];
  function renderProcessDetails(
    rowData: any,
    field: string,
    setIsParentDataInsert: Dispatch<SetStateAction<boolean>>
  ) {
    console.log("start");
    console.log("rowData", rowData);
    console.log("field", field);
    const processName = rowData[`${field}_process_name`];
    const status = rowData[`${field}_status`];
    const isEnded = rowData[`${field}_is_ended`] === 1;
    const isConditionMet =
      rowData[`${field}_is_ended`] === 0 &&
      rowData[`${field}_status`] !== "未計画";

    return (
      <>
        {processName}
        <br />
        {status}
        {isConditionMet && (
          <>
            <br />
            <SubmitPerformances
              selectedData={{
                charged_user_id: rowData[`${field}_charged_user_id`],
                charged_user_display_id:
                  rowData[`${field}_charged_user_display_id`],
                charged_user_name: rowData[`${field}_charged_user_name`],
                process_name: processName,
                equipment_name: rowData[`${field}_equipment_name`],
                records_process_id: rowData[field],
                status: status,
                estimated_time: rowData[`${field}_estimated_time`],
              }}
              type={"span"}
              setIsParentDataInsert={setIsParentDataInsert}
            />
          </>
        )}
        {isEnded && (
          <>
            <br />
            <AppearPerformances
              processId={rowData[field]}
              processName={processName}
              equipmentName={rowData[`${field}_equipment_name`]}
              type={"span"}
            />
          </>
        )}
      </>
    );
  }

  for (const element of parentArray) {
    if (element.title) {
      const title = element.title;
      const field = element.field;
      const tmpObj = {
        title: title,
        field: field,
        render: (rowData: any) => {
          if (!rowData[field]) {
            return <></>;
          } else if (field.startsWith("records_process_id_")) {
            return renderProcessDetails(rowData, field, setIsParentDataInsert);
          } else {
            return rowData[field];
          }
        },
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      };
      columnsArray.push(tmpObj);
    }
  }

  //カラムなど生成ここまで

  const [pageSize, setPageSize] = React.useState(5);
  const defaultMaterialTheme = createTheme();

  return (
    <>
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: "nowrap" },
            rowStyle: { overflowWrap: "break-word" },
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
            setSelectedId(rowData.records_process_id);
          }}
        />
      </ThemeProvider>
    </>
  );
};

export default function ProcessesProgress() {
  const auth = useAuth();
  const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
  const [parentData, setParentData] = useState<ParentDataProps[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);
  function transformData(data: any[]): any[] {
    const transformedData: any[] = [];
    const processIds: {
      [orderId: string]: { [productNumberId: string]: any };
    } = {};

    for (let i = 0; i < data.length; i++) {
      const record = data[i];
      const orderId = record.records_order_id;
      const productNumberId = record.records_product_number_id;
      const processId = record.records_process_id;
      const status = record.status.toLowerCase();
      const is_ended = record.is_ended;
      const charged_user_id = record.charged_user_id;
      const charged_user_display_id = record.charged_user_display_id;
      const charged_user_name = record.charged_user_name;
      const process_name = record.process_name;
      const equipment_name = record.equipment_name;
      const estimated_time = record.estimated_time;
      const display_id = record.display_id;
      const serial_number = record.serial_number;
      const serial_number_branch = record.serial_number_branch;
      const order_date = record.order_date;
      const customer_deadline = record.customer_deadline;

      if (!processIds[orderId]) {
        processIds[orderId] = {};
      }

      if (!processIds[orderId][productNumberId]) {
        processIds[orderId][productNumberId] = {
          count: 1,
          processId: [processId],
          status: [status],
          is_ended: [is_ended],
          charged_user_id: [charged_user_id],
          charged_user_display_id: [charged_user_display_id],
          charged_user_name: [charged_user_name],
          process_name: [process_name],
          equipment_name: [equipment_name],
          estimated_time: [estimated_time],
          display_id: [display_id],
          serial_number: [serial_number],
          serial_number_branch: [serial_number_branch],
          order_date: [order_date],
          customer_deadline: [customer_deadline],
        };
      } else {
        processIds[orderId][productNumberId].count++;
        processIds[orderId][productNumberId].processId.push(processId);
        processIds[orderId][productNumberId].status.push(status);
        processIds[orderId][productNumberId].is_ended.push(is_ended);
        processIds[orderId][productNumberId].charged_user_id.push(
          charged_user_id
        );
        processIds[orderId][productNumberId].charged_user_display_id.push(
          charged_user_display_id
        );
        processIds[orderId][productNumberId].charged_user_name.push(
          charged_user_name
        );
        processIds[orderId][productNumberId].process_name.push(process_name);
        processIds[orderId][productNumberId].equipment_name.push(
          equipment_name
        );
        processIds[orderId][productNumberId].estimated_time.push(
          estimated_time
        );
        processIds[orderId][productNumberId].display_id.push(display_id);
        processIds[orderId][productNumberId].serial_number.push(serial_number);
        processIds[orderId][productNumberId].serial_number_branch.push(
          serial_number_branch
        );
        processIds[orderId][productNumberId].order_date.push(order_date);
        processIds[orderId][productNumberId].customer_deadline.push(
          customer_deadline
        );
      }
    }

    for (const orderId in processIds) {
      for (const productNumberId in processIds[orderId]) {
        const processes = processIds[orderId][productNumberId];
        const record: any = {
          records_order_id: parseInt(orderId),
          records_product_number_id: parseInt(productNumberId),
          serial_number: processes.serial_number[0],
          serial_number_branch: processes.serial_number_branch[0],
          order_date: processes.order_date[0],
          customer_deadline: processes.customer_deadline[0],
          display_id: processes.display_id[0],
        };
        for (let i = 1; i <= processes.count; i++) {
          record["records_process_id_" + i] = processes.processId[i - 1];
          record["records_process_id_" + i + "_status"] =
            processes.status[i - 1];
          record["records_process_id_" + i + "_is_ended"] =
            processes.is_ended[i - 1];
          record["records_process_id_" + i + "_charged_user_id"] =
            processes.charged_user_id[i - 1];
          record["records_process_id_" + i + "_charged_user_display_id"] =
            processes.charged_user_display_id[i - 1];
          record["records_process_id_" + i + "_charged_user_name"] =
            processes.charged_user_name[i - 1];
          record["records_process_id_" + i + "_process_name"] =
            processes.process_name[i - 1];
          record["records_process_id_" + i + "_equipment_name"] =
            processes.equipment_name[i - 1];
          record["records_process_id_" + i + "_estimated_time"] =
            processes.estimated_time[i - 1];
        }

        transformedData.push(record);
      }
    }

    return transformedData;
  }

  useEffect(() => {
    try {
      axios
        .get(`/v0/factories/${auth.factoryId}/processes-progress`, {
          headers: auth.authorizationHeader,
        })
        .then((res: any) => {
          if (res.data.length) {
            setParentData(transformData(res.data));
          } else {
            setParentData([]);
          }
          setIsParentDataInsert(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, [auth, isParentDataInsert]);

  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>工程進捗状況一覧</PageTitle>
        <Parent
          data={parentData}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          setIsParentDataInsert={setIsParentDataInsert}
        />
      </Wrapper>
    </>
  );
}
